export default class Utils {
   constructor() {
   }

   generateStore(data) {
      let state = {}, getters = {}, mutations = {}

      for (const [key, obj] of Object.entries(data)) {
         state[key] = obj
         getters[key] = state => { return state[key] }
         mutations[key] = (state, content) => { state[key] = content }
      }

      return { state, getters, mutations }
   }

   parseData(form) {
      if (process.env.NODE_ENV === 'development') {
         $session.set('form-data', { form: form.name, data: form.data })
      }

      return form.data
   }

   registerModule(moduleName, module, store) {
      if (store.hasModule([moduleName])) {
         store.unregisterModule(moduleName)
         store.registerModule(moduleName, module)
      } else {
         store.registerModule(moduleName, module)
      }

      return true;
   }

   appendSelectData({ form, model, label, data }) {
      let options = []

      if (form) {
         for (let i = 0; i < form.forms.length; i++) {
            const $form = form.forms[i];

            if ($form.model === model) {
               for (let j = 0; j < data.length; j++) {
                  const item = data[j];
                  options.push({ val: item, label: this.getNestedObject(item, label.split('.') || '-') })
               }

               $form.options = options

               break;
            }
         }

         return form;
      } else {
         return undefined
      }
   }

   updateModelForm({ model, formModel, field,data,formName}){
      for (const [key, modelForm] of Object.entries(model.forms)) {
         if (key === formName){
            console.log(modelForm.forms)
            for (let i = 0; i < modelForm.forms.length; i++) {
               const form = modelForm.forms[i];
               
               console.log(form.model, formModel);
               if(form.model === formModel){
                  form[field] = data;
                  model.forms[i] = form
                  console.log(model.forms[i])
                  break;
               }
            }
         }
      }

      return model;
   }

   getNestedObject(nestedObj, pathArr) {
      return pathArr.reduce((obj, key) =>
         (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
   }

   generateFormData(forms) {
      let data = {}

      for (let i = 0; i < forms.length; i++) {
         const form = forms[i];

         if (form.type === 'checkbox') {
            data[form.model] = false
         } else if (form.type === 'datepicker' && form.form_type === 'daterange') {
            data[form.model] = []
         } else if (form.type === 'timepicker' && form.form_type === 'timerange') {
            data[form.model] = []
         } else if (form.type === 'form-table') {
            data[form.model] = []
         } else if (form.type === 'slider') {
            if (form.range) {
               data[form.model] = [10, 20]
            } else {
               data[form.model] = 0
            }
         } else if (form.type === 'rate') {
            data[form.model] = 0
         } else if (form.type === 'mobile') {
            data[form.model] = {
               mobile: '',
               code: {
                  callingCode: '256',
                  countryCode: 'UG'
               }
            }
         } else {
            data[form.model] = ''
         }
      }

      return data
   }

   generateAllFormData(forms) {
      for (const [key, form] of Object.entries(forms)) {
         form.name = key
         form.data = this.generateFormData(form.forms)

         if (process.env.NODE_ENV === 'development') {
            let data = $session.GET('form-data')

            if (data && key === data.form) {
               form.data = data.data
            } else {
               form.data = this.generateFormData(form.forms)
            }
         } else {
            form.data = this.generateFormData(form.forms)
         }
      }

      return forms
   }

   format(formatString, data) {
      let _data = '', count = 0
      for (let i = 0; i < formatString.length; i++) {
         const letter = formatString[i];

         if (letter === '#') {
            _data += data[count]
            count++
         } else {
            _data += letter
         }
      }

      return _data;
   }

   appendOptions(data, value, label) {
      let options = []
      for (let i = 0; i < data.length; i++) {
         const _data = data[i];
         options.push({ val: _data[value], label: _data[label] })
      }

      return options
   }

   appendOptionsObject(data, label) {
      let options = []
      for (let i = 0; i < data.length; i++) {
         const _data = data[i];
         options.push({ val: _data, label: _data[label] })
      }

      return options
   }

   printAppInfo() {
      let primary = getComputedStyle(document.documentElement).getPropertyValue('--primary');
      let secondary = getComputedStyle(document.documentElement).getPropertyValue('--secondary');

      console.log(
         '%cDeveloped by:' +
         '%csmall.shepherd@outlook.com',
         `background: ${primary}; color: #FFF; padding: 1px 5px;border-radius: 3px 0 0 3px;`,
         `background: ${secondary}; color: #FFF; padding: 1px 5px;border-radius: 0 3px 3px 0;`
      );
   }

   numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
   }

   cleanAndStoreCountries(countries, defaultCountry) {
      return new Promise((resolve, reject) => {
         try {
            let _countries = []

            for (let i = 0; i < countries.length; i++) {
               const country = countries[i];
               let selected = {
                  name: country.name,
                  alpha2Code: country.alpha2Code,
                  alpha3Code: country.alpha3Code,
                  timezones: country.timezones,
                  currencies: country.currencies,
                  flag: country.flag,
                  latlng: country.latlng,
                  callingCodes: country.callingCodes,
                  region: country.region,
                  numericCode: country.numericCode,
                  subregion: country.subregion,
               }
               _countries.push(selected)

               if (country.name.toLowerCase() === defaultCountry) {
                  $session.set('country', selected)
               }
            }

            $session.set('countries', _countries)
            resolve(_countries)
         } catch (err) {
            reject(err)
         }
      })
   }

   sleep(duration) {
      return new Promise((resolve, reject) => {
         setTimeout(() => {
            resolve(true)
         }, duration * 1000);
      })
   }

   getMapStyles() {
      var style = `[{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}]`

      return JSON.parse(style);
   }
}